import * as React from "react";
import {
  IPeerGroupTabsProps,
  IFilter,
  IVisualizationState,
} from "../../lib/http";
import * as ReactHighcharts from "react-highcharts";
import { Panel } from "react-bootstrap";
//import PanelGraph from "app/components/tabs/PanelGraph";
const HighchartsMore = require("highcharts/highcharts-more");
HighchartsMore(ReactHighcharts.Highcharts);

export class Visualization14 extends React.Component<
  IPeerGroupTabsProps,
  IVisualizationState
  > {
  state: IVisualizationState = {
    series: [],
    title: "Hello World",
    loading: false,
    filters: { assetLevel: -1 },
    data: [],
    categories: [],
  };

  componentDidMount() {
    this.setState({ data: this.props.data }, () =>
      this.loadSeries(this.props.filters)
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.filters.assetLevel !== this.props.filters.assetLevel ||
      prevProps.data.length !== this.props.data.length
    ) {
      this.setState(
        { filters: this.props.filters, data: this.props.data },
        () => {
          this.loadSeries(this.props.filters);
        }
      );
    }
  }

  loadSeries(filters: IFilter) {
    const { data } = this.state;
    let title = "";
    const categories = [];
    const segmentOne = [];
    const segmentTwo = [];
    const highLine = [];
    const medianLine = [];
    const lowLine = [];
    data.map((dataPoint, index) => {
      //NOTE: Filter Id of 0 is All Assets. Remove that from the list.
      //NOTE: We only need asset levels
      if (dataPoint.filterId > 0) {
        title = dataPoint.OpEx_T_V14_Vis14Title;
        categories.push(dataPoint.OpEx_T_V14_Vis14Col);
        segmentOne.push([
          dataPoint.OpEx_N_V14_25thOpExSpend,
          dataPoint.OpEx_N_V14_MdnOpExSpend,
        ]);
        segmentTwo.push([
          dataPoint.OpEx_N_V14_MdnOpExSpend,
          dataPoint.OpEx_N_V14_75thOpExSpend,
        ]);

        highLine.push({
          y: dataPoint.OpEx_N_V14_75thOpExSpend,
          name: dataPoint.OpEx_T_V14_Vis14Label75thOpexSpend,
        });

        medianLine.push({
          y: dataPoint.OpEx_N_V14_MdnOpExSpend,
          name: dataPoint.OpEx_T_V14_Vis14LabelMdnOpexSpend,
        });

        lowLine.push({
          y: dataPoint.OpEx_N_V14_25thOpExSpend,
          name: dataPoint.OpEx_T_V14_Vis14Label25thOpexSpend,
        });
      }
    });

    const series = [
      {
        color: "#7EA2E5",
        name: "Expense Range",
        data: segmentOne,
        marker: { symbol: "circle" },
      },
      {
        color: "#628CD9",
        name: "Expense Range",
        data: segmentTwo,
        marker: { symbol: "circle" },
      },
      {
        type: "line",
        name: "High Line",
        data: highLine,
        marker: { enabled: false },
      },
      {
        type: "line",
        name: "Median Line",
        data: medianLine,
        marker: { enabled: false },
      },
      {
        type: "line",
        name: "Low Line",
        data: lowLine,
        marker: { enabled: false },
      },
    ];

    this.setState({ title, series, categories });
  }

  static getChartConfig(series, categories) {
    return {
      chart: { type: "arearange" },
      title: {
        text: "",
      },
      yAxis: {
        visible: false,
        type: "logarithmic",
        min: 5000,
        startOnTick: false,
      },
      xAxis: { type: "category", categories },
      legend: {
        enabled: false,
      },
      plotOptions: {
        arearange: {
          dataLabels: {
            enabled: false,
            verticalAlign: "bottom",
          },
        },
        line: {
          dataLabels: {
            enabled: true,
            format: "{point.name}",
            crop: false,
            overflow: "none",
            allowOverlap: true,
          },
          lineWidth: 0,
          states: {
            hover: {
              enabled: false,
            },
          },
        },
      },
      tooltip: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      series,
    };
  }
  /*
    render() {
      const { title, loading, series, categories } = this.state;
      return (
        <PanelGraph
          title={title}
          loading={loading}
          chartConfig={Visualization14.getChartConfig(series, categories)}
        />
      );
    }
    */
  render() {
    const { title, loading, series, categories } = this.state;
    return (
      <Panel>
        <div className="panel-body text-center">
          {title}{loading && <i className="fa fa-cog fa-spin"></i>}<br />
        </div>
        <div className="panel-body">
          <ReactHighcharts config={Visualization14.getChartConfig(series, categories)} ref="chart" />
        </div>
      </Panel>
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/OperatingExpenses/Visualization14/index.tsx